import { Box, Divider } from "@mui/material";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomTooltipBorder from "../../../../components/CustomTooltipBorder";
import PermissionDetails from "./PermissionDetails";
import usePermissionType from "./usePermissionType";

const AdminSinceTooltip = ({ permissions, children, isList = false }) => {
  const colors = useColors();
  const getPermissionType = usePermissionType();
  const { trackEvent } = useAPI();

  const handleMouseEnter = () => {
    trackEvent(
      isList
        ? "user hover on admin permission chip"
        : "user hover on admin permission chip list"
    );
  };
  return (
    <CustomTooltipBorder
      borderColor={
        getPermissionType(permissions.admin_type, permissions?.admin_category)
          .borderColor
      }
      title={
        isList ? (
          <Box display="flex" flexDirection="column" gap={1} pt={1}>
            {permissions.map((permission, index) => (
              <>
                <Box>
                  <PermissionDetails permission={permission} />
                </Box>
                <Box>
                  {index < permissions.length - 1 && (
                    <Divider orientation="horizontal" flexItem />
                  )}
                </Box>
              </>
            ))}
          </Box>
        ) : (
          <PermissionDetails permission={permissions} />
        )
      }
      onMouseEnter={handleMouseEnter}
    >
      {children}
    </CustomTooltipBorder>
  );
};

export default AdminSinceTooltip;
